import dayjs from 'dayjs'

export const findClosestTime = (times) => {
  // Helper to convert "HH:mm" to total minutes
  const toMinutes = (timeStr) => {
    const [hours, minutes] = timeStr.split(':').map(Number)
    return hours * 60 + minutes
  }

  const time = dayjs().format('HH:mm')
  const currentMinutes = toMinutes(time)

  // Filter only future times
  const futureTimes = times.filter((t) => toMinutes(t) > currentMinutes)

  if (futureTimes.length === 0) {
    return times[0] // fallback to earliest time (assumed next day)
  }

  // Find closest future time
  let closestTime = futureTimes[0]
  let smallestDifference = toMinutes(closestTime) - currentMinutes

  for (const t of futureTimes) {
    const diff = toMinutes(t) - currentMinutes
    if (diff < smallestDifference) {
      smallestDifference = diff
      closestTime = t
    }
  }

  return closestTime
}

// const times = ['09:00', '14:30', '18:00', '23:45']
// console.log(findClosestTime(times))
